const ArtDirectingImage = (mobileFluid, desktopFluid) => {
  if (!mobileFluid) {
    return desktopFluid
  } else if (!desktopFluid) {
    return mobileFluid
  } else {
    return [mobileFluid, { ...desktopFluid, media: '(min-width: 1024px)' }]
  }
}

export default ArtDirectingImage
